import {ID, Resource} from 'simpli-web-sdk'
import DeliveryDriverResponseSchema from '@/schema/DeliveryDriverResponse.schema'

export default class DeliveryDriverResponse extends Resource {

  readonly $name: string = 'DeliveryDriverResponse'
  readonly $endpoint: string = '/user/indicador/entrega-por-entregador'

  get $schema() {
    return DeliveryDriverResponseSchema(this)
  }

  get $id() {
    return this.id
  }
  set $id(val: ID) {
    this.id = val
  }

  id: ID = 0
  nome: string | null = null
  qtdTotal: number | null = null
  qtdSemOcorrencia: number | null = null
  qtdComOcorrencia: number | null = null
  qtdDevolvidas: number | null = null
  documento: string | null = null
  placa: string | null = null

}
